import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";

function IndentedParagraphSmall({
  fontWeight,
  italic,
  uppercase,
  color,
  children,
}) {
  return (
    <Text
      fontSize={[16, 16, 22, 22]}
      lineHeight={["26px", "26px", "32px", "32px"]}
      fontWeight={fontWeight}
      italic={italic}
      uppercase={uppercase}
      color={color}
    >
      <span style={{ paddingRight: 60 }} />
      <span
        className="indented-paragraph"
        dangerouslySetInnerHTML={{ __html: children }}
      />
    </Text>
  );
}

export default IndentedParagraphSmall;

IndentedParagraphSmall.defaultProps = {
  color: "inherit",
};

IndentedParagraphSmall.propTypes = {
  color: PropTypes.string,
  fontWeight: PropTypes.number,
  uppercase: PropTypes.bool,
};
